<div
  class="widget-wrapper"
  [class.open]="!widgetCollapsed"
  [@openCloseWidget]="widgetCollapsed ? 'hide' : 'show'"
>
  <div
    class="widget-header"
    [@openCloseWidgetHeader]="widgetCollapsed ? 'hide' : 'show'"
    (click)="toggleWidget()"
  >
    <h4>{{ title }}</h4>
  </div>
  <div
    class="container"
    [@openCloseWidgetContent]="widgetCollapsed ? 'hide' : 'show'"
  >
    <div class="top-label reference" *ngIf="comparisonData">
      {{ labels[0] }}
    </div>
    <div *ngFor="let elem of referenceData; let i = index" class="elem">
      <ng-container *ngIf="!elem.separator">
        <p class="label">
          <span *ngIf="isRanking" class="position"
            >{{ elem.rank || i + 1 }}.</span
          >
          <span
            class="name generic-tooltip top"
            [attr.data-tooltip]="elem[labelKey] | translate"
            >{{ elem[labelKey] | translate }}</span
          >
          <span
            class="value top"
            [class.generic-tooltip]="isVisitsAvailable && stats"
            [attr.data-tooltip]="
              (getPercentageTotalValue(elem) | hideZeroValues : '1.0-1') +
              '% ' +
              ('over the total of' | translate) +
              ' ' +
              (keyIndicatorLabel | translate)
            "
          >
            {{ getValue(elem) | hideZeroValues : '1.0-0' }}
            <span>{{ unit }}</span>
          </span>
          <span
            *ngIf="elem.changed"
            class="changed"
            [class.up]="elem.changed > 0"
            [class.down]="elem.changed < 0"
          ></span>
        </p>
      </ng-container>
      <p class="label separator" *ngIf="elem.separator">...</p>
    </div>
  </div>
  <div
    class="container"
    *ngIf="comparisonData"
    [@openCloseWidgetContent]="widgetCollapsed ? 'hide' : 'show'"
  >
    <div class="top-label comparison">{{ labels[1] }}</div>
    <div *ngFor="let elem of comparisonData; let i = index" class="elem">
      <ng-container *ngIf="!elem.separator">
        <p
          class="label generic-tooltip top"
          [attr.data-tooltip]="elem.category | translate"
        >
          <span *ngIf="isRanking" class="position"
            >{{ elem.rank || i + 1 }}.</span
          >
          <span class="name">{{ elem.category | translate }}</span>
          <span class="value">
            {{ getValue(elem) | hideZeroValues : '1.0-0' }}
            <span>{{ unit }}</span>
          </span>
          <span
            *ngIf="elem.hasOwnProperty('changed')"
            class="changed"
            [class.up]="elem.changed > 0"
            [class.equal]="elem.changed === 0"
            [class.down]="elem.changed < 0"
          ></span>
        </p>
      </ng-container>
      <p class="label separator" *ngIf="elem.separator">...</p>
    </div>
  </div>
  <a class="btn-detail" *ngIf="showViewFullTable" (click)="openPopup()">{{
    'View full table' | translate
  }}</a>
</div>
